<template>
  <div>
    <table class="table table-responsive dataTable" id="addressTable">
      <thead>
      <tr>
        <th>Type</th>
        <th>Address</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(add, index) in addresses" :key="index">
        <td>{{ add.memberAddressType.description }}</td>
        <td><span v-html="displayAddress(add)"></span></td>
        <td>
          <button type="button" class="btn btn-xs btn-primary" @click="openEditModal(add, index)">
            <span class="glyphicons glyphicons-pencil"></span> Edit
          </button>
          <button type="button" class="btn btn-xs btn-danger" @click="openDeleteModal(index)">
            <span class="glyphicons glyphicons-bin"></span> Delete
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <button type="button" class="btn btn-xs btn-info" :disabled="disabled" @click="addAddress()"><span
      class="glyphicons glyphicons-plus"></span> Add Address
    </button>
    <!--    <validate-address-modal :address="address" ref="addressModal" v-on:update-address="updateAddress($event)" />-->
    <address-modal :save-url="saveUrl" :address="address" ref="editModal" v-on:update-address="updateAddress($event)"/>
    <div class="modal fade" id="delete-address-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
              aria-hidden="true">&times;</span></button>
            <h4 class="modal-title" id="myModalLabel">Delete Address</h4>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to delete address?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-danger" @click="deleteAddress()">Delete Address
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddressHelper from '../common/AddressHelper'
import ValidateAddressModal from './ValidateAddressModal'
import AddressModal from './AddressModal'
import {cloneDeep} from 'lodash'
import $ from 'jquery'
import axios from 'axios'
import Notifier from '../common/Notifier'
import FormValidationMixIn from './FormValidationMixIn'

const defaultAddress = {
  addressType: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  postalCode: '',
  country: '',
  update: false
}

export default {
  name: 'AddressList',
  components: {
    'validate-address-modal': ValidateAddressModal,
    'address-modal': AddressModal
  },
  mixins: [FormValidationMixIn],
  props: {
    addresses: {
      type: Array,
      default: []
    },
    objectId: {
      type: Object,
      required: true
    },
    saveUrl: {
      type: String,
      required: true
    },
    deleteUrl: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      address: cloneDeep(defaultAddress),
      addressId: {},
      addressIndex: 0
    }
  },
  methods: {
    displayAddress(address) {
      const button = `<a href="${AddressHelper.buildAddressLink(address)}" data-toggle="tooltip" title="Open in Bing Maps" target="_blank"><span class="glyphicons glyphicons-map-marker"></span></a>`

      return `${button} ${AddressHelper.buildAddressOneLine(address)}`
    },
    addAddress() {
      this.openEditModal(defaultAddress, this.addresses.length)
    },
    openEditModal(address, index) {
      if (this.$refs.editModal) {
        this.address = cloneDeep(address)

        for (const key in this.objectId) {
          this.address[key] = this.objectId[key]
        }

        this.addressIndex = index
        this.$refs.editModal.open()
      }
    },
    openDeleteModal(index) {
      this.addressIndex = index
      $('#delete-address-modal').modal('show')
    },
    closeDeleteModal() {
      $('#delete-address-modal').modal('hide')
      this.addressIndex = 0
    },
    deleteAddress() {
      $.blockUI({message: '<h3>Deleting address...</h3>'})
      const addressId = {
        addressType: this.addresses[this.addressIndex].addressType
      }
      for (const key in this.objectId) {
        addressId[key] = this.objectId[key]
      }

      axios.post(this.deleteUrl, addressId)
        .then(response => {
          $.unblockUI()
          if (response.data.result === 'success') {
            this.addresses.splice(this.addressIndex, 1)
            Notifier.success('Address deleted successfully.')
            this.closeDeleteModal()
          } else {
            this.saveResponse = response.data
            this.closeDeleteModal()
          }
        })
        .catch(error => {
          console.log(error.stack)
          $.unblockUI()
          this.onError('An unexpected error occurred deleting address.')
        })
    },
    updateAddress(address) {
      this.addresses.splice(this.addressIndex, 1, address)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/js/components/AddressList.vue